// extracted by mini-css-extract-plugin
export default {"container":"bfprOOhg7T0E_8LHrHbp","card":"SDRIfNGUyou8VJXY8SUC","info":"ergR6uJhWN8X21WLIj7M","label":"fKMVYOBrAxc18ffXuAG5","replace":"Vqvp8kWFcYSdrvbEhX4N"};